import { Component, Input, OnInit } from "@angular/core";
import { DataService_MultiStationViewVisitors } from "../shared/data.service";

@Component({
	selector: "caass-ms-visitor-info",
	templateUrl: "./ms-visitor-info.component.html",
	styleUrls: ["./ms-visitor-info.component.css"],
})
export class MsVisitorInfoComponent implements OnInit {
	constructor(private visitorService: DataService_MultiStationViewVisitors) {}

	ngOnInit(): void {
		this.loadDemographics();
	}

	ngOnChanges() {
		this.loadDemographics();
	}

	////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////

	@Input() SelectedVisitor: any;

	loading: boolean = false;

	State: string = "N/A";
	LicenseNbr: string = "N/A";
	IssueDate: string = "N/A";
	ExpireDate: string = "N/A";
	Address: string = "N/A";
	City: string = "N/A";
	ZipCode: string = "N/A";
	PhoneNbr: string = "N/A";
	Email: string = "N/A";
	VisitCount: string = "N/A";
	ScanCount: string = "N/A";
	FirstVisit: string = "N/A";
	LastVisit: string = "N/A";
	LongestVisit: string = "N/A";
	ShortestVisit: string = "N/A";
	AverageVisit: string = "N/A";

	lstLocationInfo: any = [];
	lstVisiteeInfo: any = [];

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////////////////////
	loadDemographics() {
		this.ClearData();

		if (this.SelectedVisitor == undefined || this.SelectedVisitor.PersonID == undefined) {
			return;
		}

		this.loading = true;

		var result = this.visitorService.VisitorDemographicInfoSelect(this.SelectedVisitor.PersonID);
		result.subscribe(
			(response: any) => {
				this.State = response.State == undefined ? "N/A" : response.State;
				this.LicenseNbr = response.LicenseNbr == undefined ? "N/A" : response.LicenseNbr;
				this.IssueDate = response.IssueDate == undefined ? "N/A" : response.IssueDate;
				this.ExpireDate = response.ExpireDate == undefined ? "N/A" : response.ExpireDate;
				this.Address = response.Address == undefined ? "N/A" : response.Address;
				this.City = response.City == undefined ? "N/A" : response.City;
				this.ZipCode = response.ZipCode == undefined ? "N/A" : response.ZipCode;
				this.PhoneNbr = response.PhoneNbr == undefined ? "N/A" : response.PhoneNbr;
				this.Email = response.Email == undefined ? "N/A" : response.Email;
				this.VisitCount = response.VisitCount == undefined ? "N/A" : response.VisitCount;
				this.ScanCount = response.ScanCount == undefined ? "N/A" : response.ScanCount;
				this.FirstVisit = response.FirstVisit == undefined ? "N/A" : response.FirstVisit;
				this.LastVisit = response.LastVisit == undefined ? "N/A" : response.LastVisit;
				this.LongestVisit = response.LongestVisit == undefined ? "N/A" : response.LongestVisit;
				this.ShortestVisit = response.ShortestVisit == undefined ? "N/A" : response.ShortestVisit;
				this.AverageVisit = response.AverageVisit == undefined ? "N/A" : response.AverageVisit;

				this.lstLocationInfo = response.lstLocationInfo == undefined ? [] : response.lstLocationInfo;
				this.lstVisiteeInfo = response.lstVisiteeInfo == undefined ? [] : response.lstVisiteeInfo;

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////////////

	ClearData() {
		this.State = "N/A";
		this.LicenseNbr = "N/A";
		this.IssueDate = "N/A";
		this.ExpireDate = "N/A";
		this.Address = "N/A";
		this.City = "N/A";
		this.ZipCode = "N/A";
		this.PhoneNbr = "N/A";
		this.Email = "N/A";
		this.VisitCount = "N/A";
		this.ScanCount = "N/A";
		this.FirstVisit = "N/A";
		this.LastVisit = "N/A";
		this.LongestVisit = "N/A";
		this.ShortestVisit = "N/A";
		this.AverageVisit = "N/A";

		this.lstLocationInfo = [];
		this.lstVisiteeInfo = [];
	}

	////////////////////////////////////////////////////////////////////////
}
